import { CDN_BASE_URL } from "../../Config/apiConfig";

export const OfflineShips = [
    // Ocean Albatros Start
    {
        shipSlug: "ocean-albatros",
        shipname: "Ocean Albatros",
        resShipUrl: "",
        banner: `${CDN_BASE_URL}/img/ships/Albatros/ocean-albatros.jpg`,
        overview: "The Ocean Albatros, sister ship to the Ocean Victory, joined Albatros Expeditions' fleet in June 2023. Designed for adventure, it navigates a diverse range of expedition cruise destinations, from Antarctica and the Arctic to other thrilling locations in between.With 94 well-appointed staterooms and suites—each offering an unobstructed sea view and most featuring a private balcony—the Ocean Albatros has quickly become one of the world's most sought-after expedition cruise vessels. Like its sister ship, it boasts two restaurants, a wellness area, the Albatros Nordic Bar, an open-deck dining facility, and a modern lecture lounge, among other state-of-the-art amenities.Committed to sustainability, the Ocean Albatros operates with over 50% lower carbon emissions than traditional expedition vessels and upholds the Green Initiative Program, ensuring an eco-friendly yet luxurious experience for guests. Setting it apart from the Ocean Victory, it features a unique panorama sauna and additional solo traveler cabins with no single-supplement, making exploration even more accessible.",
        cruiseline: "Albatros Expeditions",
        cruiselineSlug: "/cruise-lines/albatros-expeditions",
    },
    {
        shipSlug: "ocean-victory",
        shipname: "Ocean Victory",
        resShipUrl: "",
        banner: `${CDN_BASE_URL}/img/ships/Albatros/ocean-victory.jpg`,
        overview: "The Ocean Victory joined our fleet in November 2021, becoming one of the most modern small-ship vessels on the market. Purpose-built for expedition cruising, it is dedicated to diverse voyages across the Antarctic region.Featuring 93 stylish staterooms—all with ocean views and 90% with private balconies—the Ocean Victory offers an exceptional guest experience. Onboard amenities include multiple dining venues, a wellness area, the Albatros Nordic Bar, an open-deck dining facility, and a state-of-the-art lecture lounge.Designed with sustainability in mind, the vessel operates under the Green Initiative Program, combining eco-friendly practices with outstanding comfort to deliver an unforgettable expedition experience.",
        cruiseline: "Albatros Expeditions",
        cruiselineSlug: "/cruise-lines/albatros-expeditions",
    },
    // Ocean Albatros End
    // Swan Hellenic Start
    {
        shipSlug: "sh-vega",
        shipname: "SH Vega",
        resShipUrl: "",
        banner: `${CDN_BASE_URL}/img/ships/Swan/sh-vega.jpg`,
        overview: "Named after the first vessel to navigate the Arctic Northeast Passage, SH Vega is crafted for stylish and comfortable exploration of remote polar regions. This luxurious 5-star expedition ship blends elegant Scandinavian design with cutting-edge cruising technology. Its PC5 ice-strengthened hull and extra-large stabilizers ensure a smooth and stable journey. Constructed at Finland’s renowned Helsinki Shipyard, SH Vega is designed for unforgettable cruising experiences. With inviting spaces to unwind, panoramic views, and exceptional dining, staterooms, and amenities, every voyage aboard SH Vega is a true pleasure.",
        cruiseline: "Swan Hellenic",
        cruiselineSlug: "/cruise-lines/swanhellenic",
    },
    {
        shipSlug: "sh-diana",
        shipname: "SH Diana",
        resShipUrl: "",
        banner: `${CDN_BASE_URL}/img/ships/Swan/sh-diana.jpg`,
        overview: "Built at Finland’s Helsinki Shipyard, SH Diana blends cutting-edge technology with elegant design for an unparalleled expedition experience. Named after the Roman goddess of the wilderness, this 5-star ship features a PC6 ice-strengthened hull, luxurious interiors, world-class dining, and panoramic views. With dedicated expedition facilities and sophisticated amenities, SH Diana is your gateway to exploring the world's most remote destinations in style.",
        cruiseline: "Swan Hellenic",
        cruiselineSlug: "/cruise-lines/swanhellenic",
    },
    // Oceanwide Expeditions Start
    {
        shipSlug: "mv-hondius",
        shipname: "m/v Hondius",
        resShipUrl: "",
        banner: `${CDN_BASE_URL}/img/ships/Ocean Wide/oceanwide.webp`,
        overview: "Hondius is the world’s first Polar Class 6 vessel to be officially registered and was purpose-built from the ground up for expedition cruising.",
        cruiseline: "Oceanwide Expeditions",
        cruiselineSlug: "/expedition-cruise-lines/oceanwide-expeditions",
    },
    {
        shipSlug: "mv-ortelius",
        shipname: "m/v Ortelius",
        resShipUrl: "",
        banner: `${CDN_BASE_URL}/img/ships/Ocean Wide/ortelius.webp`,
        overview: "The ice-strengthened Ortelius is fully equipped for polar expeditions and capable of supporting helicopter operations when needed.",
        cruiseline: "Oceanwide Expeditions",
        cruiselineSlug: "/expedition-cruise-lines/oceanwide-expeditions",
    },
    {
        shipSlug: "mv-plancius",
        shipname: "m/v Plancius",
        resShipUrl: "",
        banner: `${CDN_BASE_URL}/img/ships/Ocean Wide/plancius.webp`,
        overview: "Plancius, our longest-serving vessel, remains a timeless favorite for many of our most popular polar journeys.",
        cruiseline: "Oceanwide Expeditions",
        cruiselineSlug: "/expedition-cruise-lines/oceanwide-expeditions",
    },
    {
        shipSlug: "sv-rembrandt-van-rijn",
        shipname: "s/v Rembrandt van Rijn",
        resShipUrl: "",
        banner: `${CDN_BASE_URL}/img/ships/Ocean Wide/rembrandt.webp`,
        overview: "Our three-mast schooner, Rembrandt van Rijn, is well suited for expedition cruising among the fjords of Greenland and Spitsbergen.",
        cruiseline: "Oceanwide Expeditions",
        cruiselineSlug: "/expedition-cruise-lines/oceanwide-expeditions",
    },
    //66Exp Start
    {
        shipSlug: "ms-seaventure",
        shipname: "Ms Seaventure",
        resShipUrl: "",
        banner: `${CDN_BASE_URL}/img/ships/66Exp/expeditions66.png`,
        overview: "Ms Seaventure is the first passenger ship purpose-built for polar exploration, boasting the highest ice-class rating of 1A SUPER. With over 300 safe voyages across the Arctic and Antarctic, it underwent a major upgrade in 2022 to enhance comfort while retaining its small-ship charm. Onboard, guests enjoy a range of amenities including restaurants, a bar, library, sauna, gym, and an expedition lounge. A nearly 1:1 passenger-to-crew ratio ensures highly personalized service throughout the journey.",
        cruiseline: "66° Expeditions",
        cruiselineSlug: "/expedition-cruise-lines/expeditions66",
    },
    //66Exp End
]

// {
//     shipSlug: "mv-hondius", shipname: "m/v Hondius",
//     resShipUrl: "",
//   },
//   {
//     shipSlug: "mv-ortelius", shipname: "m/v Ortelius",
//     resShipUrl: "",
//   },
//   {
//     shipSlug: "mv-plancius", shipname: "m/v Plancius",
//     resShipUrl: "",
//   },
//   {
//     shipSlug: "sv-rembrandt-van-rijn", shipname: "s/v Rembrandt van Rijn",
//     resShipUrl: "",
//   },